module.exports = __webpack_public_path__ + "static/img/smile4.a0f3310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smile4.png
// module id = rjos
// module chunks = 2